export default __webpack_public_path__ + "static/media/dubai.850415db.svg";